import React from 'react';
import classes from './Hero.module.scss';
import Header from './Header/Header';
import Button from '../UI/Button/Button';

const Hero = () => {
  return (
    <div className={classes.Hero}>
      <video className={classes.VideoBG} loop autoPlay muted>
        <source src="https://player.vimeo.com/external/385075254.hd.mp4?s=df2b6c79e9eb66a6a5f56a4d68930415bf35d202&profile_id=175&oauth2_token_id=57447761&download=1" type="video/mp4" />
      </video>

      <Header />

      <div className={classes.TextContents}>
        <h2 className={classes.Title}>A thing that you see in my pictures is that I was not afraid to fall in love with these people.</h2>

        <Button>Explore</Button>
      </div>      
    </div>
  );
}

export default Hero;
